export const toTimeSpan = ({
  hours = 0,
  minutes = 0,
  days = 0,
  seconds = 0
}: {
  hours?: number;
  minutes?: number;
  days?: number;
  seconds?: number;
}) => {
  return `${days}.${hours > 9 ? "" : 0}${hours}:${
    minutes > 9 ? "" : 0
  }${minutes}:${seconds > 9 ? "" : 0}${seconds}`;
};

export const fromTimeSpan = (timeSpan: string | undefined | null) => {
  if (!timeSpan) {
    return {
      days: 0,
      hours: 0,
      minutes: 0
    };
  }

  if (timeSpan.indexOf(".") === -1) {
    const [hours, minutes, seconds] = timeSpan.split(":");
    return {
      days: 0,
      hours: hours ? Number(hours) : 0,
      minutes: minutes ? Number(minutes) : 0,
      seconds: seconds ? Number(seconds) : 0
    };
  }

  const [days, rest] = timeSpan.split(".");
  const [hours, minutes, seconds] = rest.split(":");

  return {
    days: days ? Number(days) : 0,
    hours: hours ? Number(hours) : 0,
    minutes: minutes ? Number(minutes) : 0,
    seconds: seconds ? Number(seconds) : 0
  };
};
